import { Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-stone-200 bg-white py-16" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid gap-12 md:grid-cols-2">
          <div>
            <p className="font-display text-lg font-black uppercase tracking-tight text-stone-900">
              BeanGo Cube<span className="text-gold">®</span> X
            </p>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-stone-500">
              Výhradní dovozce chytrých pražiček BeanGo Cube® pro Českou republiku a Slovensko.
            </p>
            <p className="mt-3 text-sm font-medium text-stone-600">Gala story s.r.o. · IČO: 11905646</p>
          </div>
          <div className="md:text-right">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-stone-400">Kontakt</p>
            <ul className="mt-4 space-y-2 text-sm text-stone-600">
              <li>
                <a href="mailto:info@galacoffee.cz" className="transition-colors duration-300 hover:text-stone-900" data-testid="footer-email-link">
                  info@galacoffee.cz
                </a>
              </li>
              <li>
                <a href="tel:+420731775208" className="transition-colors duration-300 hover:text-stone-900" data-testid="footer-phone-link">
                  +420 731 775 208
                </a>
              </li>
              <li>Nové sady 25, 602 00 Brno</li>
              <li>
                <a href="https://instagram.com/beangocube_cz_sk" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-stone-900 md:justify-end" data-testid="footer-instagram-link">
                  <Instagram className="h-3.5 w-3.5" aria-hidden="true" />
                  @beangocube_cz_sk
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-3 border-t border-stone-200 pt-8 text-xs text-stone-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 Gala story s.r.o. — výhradní dovozce BeanGo Cube® pro ČR a SR · beangocube.cz</p>
          <p>BeanGo Cube® je značka společnosti Jiyonson. Navrženo a vyrobeno na Tchaj-wanu.</p>
        </div>
      </div>
    </footer>
  );
}
